import * as constants from './constants';

export function setDefaultProvince(data) {
  return { type: constants.SET_DEFAULT_PROVINCE, payload: data };
}

export function setDefaultCity(value) {
  return { type: constants.SET_DEFAULT_CITY, payload: value };
}
